<template>
    <div class="autologin-info">
        <template v-if="data">
            <table class="autologin-info__container">
                <thead>
                <tr>
                    <th>Key</th>
                    <th>Value</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="item of data">
                    <td>{{item.name}}</td>
                    <td>{{item.value}}</td>
                </tr>
                </tbody>
            </table>
        </template>

        <no-data v-else/>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler"
import send from "@/utils/fetch"

export default {
    name: 'autologinInfo',

    props: ['popupData', 'popupType', 'popupButton'],

    data() {
        return {
            data: null
        }
    },

    methods: {
        getObjectKeys(obj, parentKey = '') {
            return Object.entries(obj).reduce((keys, [key, value]) => {
                const fullKey = parentKey ? `${parentKey}.${key}` : key;
                return typeof value === 'object' && value !== null && !Array.isArray(value)
                    ? [...keys, ...this.getObjectKeys(value, fullKey)]
                    : [...keys, fullKey]
            }, [])
        },

        createTableHeaders(data) {
            return this.getObjectKeys(data)
                .map(item => {
                    const name = item.split('.').pop()

                    return {
                        name: item,
                        key: name,
                        value: name,
                        display: true
                    }
                })
        },

        getValueByPath(obj, path) {
            return path.split('.').reduce((acc, key) => acc && acc[key], obj)
        },

        getDataByHeaders(data, headers) {
            return headers.map(header => {
                return {
                    name: header.name,
                    key: header.key,
                    value: this.getValueByPath(data, header.name) || null
                }
            })
        },

        async getData() {
            try {
                this.data = await send(`${this.$url.statistic.autologinInfo}/${this.popupData}/meta`, 'GET')
                    .then(response => response.data.result.autologin)
                    .then(response => this.getDataByHeaders(response, this.createTableHeaders(response)))
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        try {
            await this.getData()
            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
        }

    }
}
</script>

<style lang="scss">
.autologin-info {
    &__container {
        border-collapse: collapse;

        tr {
            &:nth-child(2n) {
                td {
                    background-color: rgba(var(--vs-bodyBg), 1);
                }
            }

            td {
                padding: 10px;

                &:first-child {
                    border-top-left-radius: .5rem;
                    border-bottom-left-radius: .5rem;
                }

                &:last-child {
                    border-top-right-radius: .5rem;
                    border-bottom-right-radius: .5rem;
                }
            }
        }
    }
}
</style>
